module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoAQMAAAC2MCouAAAAA3NCSVQICAjb4U/gAAAABlBMVEX///8AAABVwtN+AAAACXBIWXMAAAsSAAALEgHS3X78AAAAFnRFWHRDcmVhdGlvbiBUaW1lADA5LzA5LzExmFHs7gAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNXG14zYAAAAoSURBVAiZY5ADAQYbEGCoAAGGDyDA8BAEGA6DAEM7CDDwgwDDEFcPACgiY52TozcxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// M:/_work/1/s/Core/OnBase.NET/third-party-assemblies/Infragistics/IgniteUI/16.2.20162.2040/css/structure/images/igGrid/diagonals-medium.png
// module id = 289
// module chunks = 0